import { useState } from "react";
import { useNavigate } from "react-router-dom";

function LEDGroupedCard({ group, handleWhatsAppOrder }) {
  const navigate = useNavigate();
  const selectedVariant = group.products[0]; // Always use first product as template
  const [selectedSize, setSelectedSize] = useState(selectedVariant.availableSizes?.[0]);

  // Get the price info for currently selected size
  const getCurrentPriceInfo = () => {
    if (!selectedSize || !selectedVariant.availableSizes) {
      return {
        price: selectedVariant.price,
        originalPrice: selectedVariant.originalPrice,
        discount: selectedVariant.discount
      };
    }

    const sizeInfo = selectedVariant.availableSizes.find(s => s.size === selectedSize.size);
    return sizeInfo || {
      price: selectedVariant.price,
      originalPrice: selectedVariant.originalPrice,
      discount: selectedVariant.discount
    };
  };

  const currentPrice = getCurrentPriceInfo();

  return (
    <div className="product-card led-grouped-card">
      <div
        className="product-image"
        onClick={() => navigate(`/product/${selectedVariant.id}`)}
        style={{ cursor: 'pointer' }}
      >
        <img src={selectedVariant.image} alt={selectedVariant.name} />
      </div>

      <h3
        onClick={() => navigate(`/product/${selectedVariant.id}`)}
        style={{ cursor: 'pointer' }}
      >
        {selectedVariant.name}
      </h3>

      {/* Size Selector - only show buttons if multiple sizes */}
      {selectedVariant.availableSizes && selectedVariant.availableSizes.length > 1 && (
        <div className="led-size-selector">
          <label>Screen Size:</label>
          <div className="size-options">
            {selectedVariant.availableSizes.map((sizeInfo, index) => (
              <button
                key={index}
                className={`size-option ${selectedSize?.size === sizeInfo.size ? 'active' : ''}`}
                onClick={() => setSelectedSize(sizeInfo)}
                title={sizeInfo.width && sizeInfo.height ? `${sizeInfo.width}" × ${sizeInfo.height}" (W×H)` : sizeInfo.size}
              >
                {sizeInfo.size}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Display size and dimensions - show for all products */}
      {selectedSize && (
        <div className="led-size-info">
          {selectedVariant.availableSizes && selectedVariant.availableSizes.length === 1 && (
            <div className="led-single-size">
              <span className="size-label">Screen Size:</span>
              <span className="size-value">{selectedSize.size}</span>
            </div>
          )}
          {selectedSize.width && selectedSize.height && (
            <div className="led-dimensions">
              <span className="dimensions-label">Dimensions:</span>
              <span className="dimensions-value">{selectedSize.width}" × {selectedSize.height}"</span>
              <span className="dimensions-note">(Width × Height)</span>
            </div>
          )}
        </div>
      )}

      <div className="product-specs">
        <span className="spec">{selectedVariant.resolution}</span>
        <span className="spec">{selectedVariant.refreshRate}</span>
      </div>

      <div className="product-price-section">
        <div className="price-info">
          <p className="current-price">PKR {currentPrice.price.toLocaleString()}</p>
          {currentPrice.discount > 0 && (
            <p className="original-price">PKR {currentPrice.originalPrice.toLocaleString()}</p>
          )}
        </div>
      </div>

      <button
        className="btn-add-to-cart"
        onClick={(e) => {
          e.stopPropagation();
          handleWhatsAppOrder(selectedVariant);
        }}
      >
        Shop Now
      </button>
    </div>
  );
}

export default LEDGroupedCard;
